import React, { createContext, useContext, useState } from 'react';

// Create the context
const ReportContext = createContext();

// Create a custom hook to use the context
export function useReport() {
  return useContext(ReportContext);
}

// Create the context provider component
export function ReportProvider({ children }) {
  const [report, newReport] = useState(1);

  const handleNewReportNotification = (newvalue) => {
    newReport(newvalue);
  };

  const value = {
    report,
    handleNewReportNotification,
  };

  return (
    <ReportContext.Provider value={value}>
      {children}
    </ReportContext.Provider>
  );
}
